const WEB3FORMS_ENDPOINT = "https://api.web3forms.com/submit";
const WEB3FORMS_ACCESS_KEY = import.meta.env.VITE_WEB3FORMS_ACCESS_KEY;
const FALLBACK_EMAIL = "info@parvatiistays.com";

export type LeadFormPayload = {
  formName: string;
  name: string;
  phone: string;
  email?: string;
  message?: string;
  metadata?: Record<string, string>;
  honeypot?: string;
};

export type LeadFormResult = {
  ok: boolean;
  message: string;
};

export const submitLeadForm = async (payload: LeadFormPayload): Promise<LeadFormResult> => {
  if (payload.honeypot?.trim()) {
    return {
      ok: true,
      message: "Thanks. Your details were submitted successfully.",
    };
  }

  if (!WEB3FORMS_ACCESS_KEY) {
    return {
      ok: false,
      message: "Lead form is not configured. Add VITE_WEB3FORMS_ACCESS_KEY to enable submissions.",
    };
  }

  const body: Record<string, string> = {
    access_key: WEB3FORMS_ACCESS_KEY,
    subject: `New lead from ${payload.formName}`,
    from_name: payload.name.trim() || "ParvatiiStays Website",
    botcheck: payload.honeypot?.trim() || "",
    name: payload.name.trim(),
    email: payload.email?.trim() || FALLBACK_EMAIL,
    replyto: payload.email?.trim() || FALLBACK_EMAIL,
    phone: payload.phone.trim(),
    form_name: payload.formName,
    source_page: typeof window !== "undefined" ? window.location.href : "",
  };

  if (payload.message) {
    body.message = payload.message;
  }

  if (payload.metadata) {
    Object.entries(payload.metadata).forEach(([key, value]) => {
      body[`meta_${key}`] = value;
    });
  }

  try {
    const response = await fetch(WEB3FORMS_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(body),
    });

    const result = (await response.json().catch(() => null)) as { success?: boolean; message?: string } | null;

    if (!response.ok || !result?.success) {
      return {
        ok: false,
        message: result?.message || "We could not submit your details right now. Please try again.",
      };
    }

    return {
      ok: true,
      message: "Thanks. Your details were submitted successfully.",
    };
  } catch {
    return {
      ok: false,
      message: "Network issue while submitting. Please try again.",
    };
  }
};
